import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Main',
    component: () => import('../views/MainPage.vue'),
    children: [
      {
        path: '',
        name: 'Chat',
        component: () => import('../views/ChatView.vue')
      },
      {
        path: 'chat/:id',
        name: 'ChatDetail',
        component: () => import('../views/ChatView.vue'),
        props: true
      },
      {
        path: 'genimg',
        name: 'GenImg',
        component: () => import('../views/GenImgView.vue')
      },
      {
        path: 'genimg/:id',
        name: 'GenImgDetail',
        component: () => import('../views/GenImgView.vue'),
        props: true
      }
    ]
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('../views/TestView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
